import type { ComponentType, ReactNode } from 'react'

type StatCardColor = 'blue' | 'amber' | 'emerald' | 'purple' | 'rose' | 'teal'

interface IconProps {
  className?: string
}

interface StatCardProps {
  label: string
  value: ReactNode
  icon: ComponentType<IconProps>
  iconColor: StatCardColor
  period?: string
  context?: ReactNode
  className?: string
}

const iconColorClasses: Record<StatCardColor, string> = {
  blue: 'bg-brand-50 text-brand-700',
  amber: 'bg-amber-50 text-amber-700',
  emerald: 'bg-emerald-50 text-emerald-700',
  purple: 'bg-purple-50 text-purple-700',
  rose: 'bg-rose-50 text-rose-700',
  teal: 'bg-teal-50 text-teal-700',
}

export function StatCard({
  label,
  value,
  icon: Icon,
  iconColor,
  period,
  context,
  className = '',
}: StatCardProps) {
  return (
    <div className={`rounded-2xl border border-line bg-white p-card shadow-card ${className}`}>
      <div className="flex items-start justify-between gap-3">
        <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${iconColorClasses[iconColor]}`}>
          <Icon className="h-5 w-5" />
        </div>
        {period ? (
          <span className="rounded-full bg-brand-50 px-2 py-1 text-xs font-medium text-brand-800">
            {period}
          </span>
        ) : null}
      </div>
      <div className="mt-4">
        <p className="text-sm font-medium text-muted">{label}</p>
        <div className="mt-2 text-3xl font-semibold leading-none tracking-tight text-ink">{value}</div>
        {context ? (
          <div className="mt-2 text-sm text-muted">{context}</div>
        ) : null}
      </div>
    </div>
  )
}
